// Filename: SearchFilterManager.ts

export interface SearchFilterManager {
    open: boolean;
    selected: string[];
    toggleSelection: (event: Event, value: string) => void;
    displaySelected: () => string;
}

export default function SearchFilterManager(): SearchFilterManager {
    return {
        open: false,
        selected: [],

        toggleSelection(event: Event, value: string) {
            const target = event.target as HTMLInputElement;

            if (target.checked) {
                this.selected.push(value);
            } else {
                this.selected = this.selected.filter((item) => item !== value);
            }
        },

        displaySelected() {
            return this.selected.length > 0
                ? this.selected.join(', ')
                : 'Select an option';
        },
    };
}
